<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Connections</v-card-title>
          <v-card-subtitle>
            Total connections:
            <span class="font-weight-bold"> {{ totalNoOfConnections }}</span>
          </v-card-subtitle>

          <v-card-text>
            <v-sheet>
              <template v-for="connection in connections">
                <div
                  class="d-flex justify-start align-center"
                  :key="connection.connectionId"
                >
                  <v-sheet
                    color="#f6f7fc"
                    outlined
                    class="my-2 rounded-lg d-inline mr-2"
                    width="300"
                  >
                    <v-list-item>
                      <UserAvatar
                        :key="connection.connectionId"
                        :usersInitials="
                          connection.firstName0 + connection.lastName0
                        "
                        :displayImageUrl="connection.displayImageUrl0"
                      />

                      <v-list-item-content>
                        <v-list-item-title>{{
                          connection.firstName0 + " " + connection.lastName0
                        }}</v-list-item-title>
                        <v-list-item-subtitle class="text-">{{
                          getConnection0Subtitle(connection)
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-sheet>

                  <hr
                    style="
                      width: 30%;
                      height: 0px;
                      border-top: 5px dotted #5160774d;
                      border-style: dotted none none none;
                    "
                  />

                  <v-icon color="grey lighten-2" class="mx-1">mdi-disc</v-icon>

                  <hr
                    style="
                      width: 30%;
                      height: 0px;
                      border-top: 5px dotted #5160774d;
                      border-style: dotted none none none;
                    "
                  />

                  <v-sheet
                    color="#f6f7fc"
                    outlined
                    class="my-2 rounded-lg d-inline ml-2"
                    width="300"
                    :key="connection.connectionId"
                  >
                    <v-list-item>
                      <UserAvatar
                        :key="connection.connectionId"
                        :usersInitials="
                          connection.firstName1 + connection.lastName1
                        "
                        :displayImageUrl="connection.displayImageUrl1"
                      />

                      <v-list-item-content>
                        <v-list-item-title>{{
                          connection.firstName1 + " " + connection.lastName1
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          getConnection1Subtitle(connection)
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-sheet>
                </div>
              </template>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Utility from "@/shared/utility";
import UserAvatar from "@/components/UserAvatar";
import { mapActions, mapGetters } from "vuex";
import {getEventDoc, getQueryConnectionsCollection} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";

export default {
  data() {
    return {
      dialog: false,
      connections: [],
      eventId: "",
      search: "",
      breadcrumbItems: [
        {
          text: "EventConnect",
          disabled: false,
          to: "/multiConnect",
        },
      ],
      showError: false,
    };
  },
  computed: {
    ...mapGetters(["currentEvent", "totalNoOfConnections"]),
  },
  components: {
    UserAvatar,
  },
  async created() {
    this.eventId = this.$route.params.eventId;

    if (this.currentEvent == null) {
      //Get the doc from firestore
      try {
        let eventDoc = await getEventDoc(this.eventId);

        //Set the current doc
        if (eventDoc.exists) this.setCurrentEvent(eventDoc.data());
        else this.showError = true;
      } catch (error) {
        console.log(
          "Error occurred while fetching event from firestore on connections page: ",
          error
        );
      }
    }

    this.connections = [];
    let querySnapshot = await getQueryConnectionsCollection(
        where("multiConnectEventId", "==", this.eventId),
        where("isAccepted", "==", true));
    querySnapshot.forEach((documentSanpshot) => {
      const documentData = documentSanpshot.data();

      this.connections.push({
        connectionId: documentSanpshot.id,
        ...documentData,
      });
    });

    console.log("connections: ", this.connections);

    this.breadcrumbItems.push({
      text: this.currentEvent.name,
      disabled: true,
    });
  },
  methods: {
    ...mapActions(["setCurrentEvent"]),
    customSearch(value, search, item) {
      search = search.toLowerCase();

      return Object.values(item).some((value) => {
        let name = item.firstName + " " + item.lastName;
        return (
          value.toLowerCase().includes(search) ||
          name.toLowerCase().includes(search)
        );
      });
    },
    getConnection0Subtitle(connection) {
      if (connection.jobTitle0 && connection.businessName0) {
        return connection.jobTitle0 + " at " + connection.businessName0;
      } else if (connection.jobTitle0) return connection.jobTitle0;
      else if (connection.businessName0) return connection.businessName0;
      else return "";
    },
    getConnection1Subtitle(connection) {
      if (connection.jobTitle1 && connection.businessName1) {
        return connection.jobTitle1 + " at " + connection.businessName1;
      } else if (connection.jobTitle1) return connection.jobTitle1;
      else if (connection.businessName1) return connection.businessName1;
      else return "";
    },
  },
};
</script>

<style>
</style>